<template>
  <div class="content-wrapper">
    <h2 class="impact-light plan-count">Plans: <strong>{{ plans.length + memberPlans.length }}</strong></h2>

    <section class="cta-wrapper">
      <Plan v-for="plan in plans" v-bind:key="plan.id" v-bind:plan="plan" v-bind:systemAdmin="(user.userType === 1) ? true : false"/>
      <Plan v-for="memberPlan in memberPlans" v-bind:key="memberPlan.id" v-bind:plan="memberPlan" v-bind:memberPlan="true"/>
    </section>
  </div>
</template>

<script>
import Plan from '@/components/plans/PlanBlock.vue'

import { adminService } from '@/services/admin.service'
import { planService } from '@/services/plan.service'
import { groupService } from '@/services/group.service'

export default {
  name: 'Plans',
  components: {
    Plan
  },
  data () {
    return {
      user: {},
      plans: [],
      memberPlans: []
    }
  },
  mounted: function () {
    // grab the user
    let user = JSON.parse(localStorage.getItem('user'))
    this.user = user.userInfo

    // Site Admin...
    if(user.userInfo.userType === 1) {
      adminService.planSearch('').then((plans) => {
        this.parseAdminPlans(plans)
        this.$forceUpdate()
      })
    }
    // everyone else.
    else {
      // grab my plans
      planService.myPlans().then(plans => {
        this.parseAdminPlans(plans)

        // grab my groups
        groupService.getGroups().then(groups => {
          this.parseMemberPlans(groups)
          this.$forceUpdate()
        })
        this.$forceUpdate()
      })
    }
  },
  methods: {
    // Somehow getting duplicates in admin plan results, so dedup them.
    parseAdminPlans: function (plans) {
      for(let plan of plans) {
        if(this.plans.map((p) => { return p.id }).indexOf(plan.id) === -1
          && !plan.enabled) {
          if(plan.description){
            plan.description = decodeURIComponent(atob(plan.description))
          }
          this.plans.push(plan)
        }
      }
    },
    // Pull out planId's and planNames from my group list.
    parseMemberPlans: function (groups) {
      for(let group of groups) {
        this.parseMemberPlan(group)
      }
    },
    parseMemberPlan: function(group){
      planService.getPlanByMember(group.planId).then(plan => {
        let memberPlan = {}
        memberPlan = {
          id: group.planId,
          name: group.planName,
          planEnabled: plan.enabled
        }

        // Duplicate checking
        if(this.plans.map((p) => { return p.id }).indexOf(memberPlan.id) === -1
          && this.memberPlans.map((n) => { return n.id }).indexOf(memberPlan.id) === -1
          && !plan.enabled) {
          this.memberPlans.push(memberPlan)
        }
      }).catch((err) => {
        console.error('Something went wrong fetching plan: ', err)
      })
    }
  }
}
</script>
